<footer class="site-footer" appFadeIn>
  <div *ngIf="isPolicyPage() || isConfirmationPage(); else normalFooter" class="footer-bottom">
    &copy; 2025 Juno Audit™. Wszelkie prawa zastrzeżone.
  </div>
  <ng-template #normalFooter>
    <div class="container footer-flex">
      <div class="footer-col footer-brand">
        <span class="footer-logo">Juno Audit™</span>
        <p class="footer-desc">
          Platforma wspierająca audyt i kontrolę jakości.<br>
          Pomagamy zespołom audytorskim działać skuteczniej i nowocześniej.
        </p>
        <div class="footer-social">
          <a href="#"><i class="fa-brands fa-facebook-f"></i></a>
          <a href="#"><i class="fa-brands fa-twitter"></i></a>
          <a href="#"><i class="fa-brands fa-linkedin-in"></i></a>
          <a href="#"><i class="fa-brands fa-envelope"></i></a>
        </div>
      </div>
      <div class="footer-col">
        <h4>Nawiguj</h4>
        <ul>
          <li><a href="#" (click)="scrollTo('juno', $event)">Jak to działa</a></li>
          <li><a href="#" (click)="scrollTo('benefits', $event)">Funkcje platformy</a></li>
          <li><a href="#" (click)="scrollTo('partners', $event)">Dla kogo</a></li>
          <li><a href="#" (click)="scrollTo('example', $event)">Zalety Juno Pilot</a></li>
        </ul>
      </div>
      <div class="footer-col">
        <h4>Legal</h4>
        <ul>
          <li><a routerLink="/polityka-prywatnosci">Polityka prywatności</a></li>
          <li><a href="#" (click)="scrollTo('JoinUs', $event)">Kontakt</a></li>
        </ul>
      </div>
    </div>
    <div class="footer-bottom">
      &copy; 2025 Juno Audit™. Wszelkie prawa zastrzeżone.
    </div>
  </ng-template>
</footer>